import * as HeroIconsSolid from '@heroicons/react/solid';
import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { colors } from '../style/colors';
import { Text } from '../Text';
import { appendClassProps } from '../util';
/**
 - Use text for any text on the screen to conform to typography styles
 */
export const Label = ({ children, dark, windowMode, className, tooltip, textColor }) => {
    useEffect(() => {
        ReactTooltip.rebuild();
    }, [children, className, tooltip]);
    const labelColor = textColor ?? 'text-blue-500';
    return (React.createElement("div", { className: `overflow-hidden flex flex-row items-center gap-1${appendClassProps(className)}`, "data-testid": "label" },
        React.createElement(Text, { overrideColor: true, className: `${dark ? 'text-white text-shadow' : labelColor}`, overflow: "ellipsis" }, children),
        tooltip && (React.createElement("div", { title: windowMode ? tooltip : undefined },
            React.createElement(HeroIconsSolid.InformationCircleIcon, { "data-testid": "tooltip", className: `h-4 w-4 ${dark ? 'text-blue-400' : 'text-blue-800'}`, "data-tip": tooltip }),
            !windowMode && (React.createElement(ReactTooltip, { className: "z-900", effect: "solid", textColor: colors.gray['50'], backgroundColor: colors.blue['800'], place: "right" }))))));
};
//# sourceMappingURL=index.js.map